/** Passport seal — shield + caduceus (brand layers). */
export function PassportMark({ className = "passport-mark" }: { className?: string }) {
  return (
    <span className={className} aria-hidden="true">
      <svg viewBox="0 0 100 100" width="100%" height="100%">
        <path
          d="M50 4 L92 22 L92 50 Q92 82 50 98 Q8 82 8 50 L8 22 Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="7"
          strokeLinejoin="round"
        />
        <line
          x1="50"
          y1="30"
          x2="50"
          y2="76"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M50 34 C38 40 38 50 50 54 C62 58 62 68 50 74"
          fill="none"
          stroke="currentColor"
          strokeWidth="4.5"
          strokeLinecap="round"
        />
        <path
          d="M50 34 C62 40 62 50 50 54 C38 58 38 68 50 74"
          fill="none"
          stroke="currentColor"
          strokeWidth="4.5"
          strokeLinecap="round"
        />
        <path d="M50 36 C40 30 28 32 22 26 C30 24 42 26 50 32 Z" fill="currentColor" />
        <path d="M50 36 C60 30 72 32 78 26 C70 24 58 26 50 32 Z" fill="currentColor" />
      </svg>
    </span>
  );
}
